module.exports = __webpack_public_path__ + "img/Store-Locator-Form.4c860129.png";